import type { FreelancerStatus } from "@/types/freelancer-rating";

/**
 * Tradução entre o status manual "legado" (freelancer_avaliacoes.status, ainda usado
 * na UI de edição) e o modelo de sinais (availability_signals / v_availability_summary),
 * que é a fonte única de disponibilidade. Um lugar só — evita mapas soltos duplicados
 * no kanban e no dialog.
 *
 * Espelha o mapa da M136 §2 / trigger M142 no backend:
 *   disponivel                   -> interesse_freela = topa_freela
 *   indisponivel                 -> interesse_freela = nao_topa
 *   temporariamente_indisponivel -> interesse_freela = nao_topa  (o "temporário" fica na observação)
 *   trabalhando_fixo             -> situacao_emprego = empregado_fixo
 *   nao_avaliado                 -> retrai o sinal (não escreve valor)
 */

export type DimensaoDisponibilidadeManual = "interesse_freela" | "situacao_emprego";

export interface SinalDisponibilidade {
  dimension: DimensaoDisponibilidadeManual;
  value: string;
}

/** Status manual mapeável -> sinal (eixo + valor). 'nao_avaliado' fica de fora (retrai). */
export const STATUS_LEGADO_PARA_SINAL: Record<
  Exclude<FreelancerStatus, "nao_avaliado">,
  SinalDisponibilidade
> = {
  disponivel: { dimension: "interesse_freela", value: "topa_freela" },
  indisponivel: { dimension: "interesse_freela", value: "nao_topa" },
  temporariamente_indisponivel: { dimension: "interesse_freela", value: "nao_topa" },
  trabalhando_fixo: { dimension: "situacao_emprego", value: "empregado_fixo" },
};

/** Eixos que a marcação manual controla — usados p/ retrair quando volta a 'nao_avaliado'. */
export const DIMENSOES_DISPONIBILIDADE_MANUAL: DimensaoDisponibilidadeManual[] = [
  "interesse_freela",
  "situacao_emprego",
];
